import clsx from "clsx";
import { forwardRef } from "react";
import { useFormContext } from "react-hook-form";
import mergeRefs from "react-merge-refs";

interface Props {
  className?: string;
  name: string;
  required?: boolean;
  textarea?: boolean;
  defaultValue?: string;
}

const NoticeTextField = forwardRef<HTMLInputElement, Props>(
  ({ className, name, required, textarea, defaultValue = "" }, ref) => {
    const {
      register,
      formState: { errors },
    } = useFormContext();

    if (textarea) {
      return (
        <textarea
          {...register(name, { required, value: defaultValue })}
          // @ts-expect-error
          ref={mergeRefs([register(name).ref, ref])}
          className={clsx(
            "resize-none h-[20.625rem] w-full rounded-md border border-secondary px-3 py-[0.438rem] outline-none",
            { "!border-red": errors[name] },
            className,
          )}
        />
      );
    }

    return (
      <input
        {...register(name, { required, value: defaultValue })}
        ref={mergeRefs([register(name).ref, ref])}
        type="text"
        className={clsx(
          "h-9 w-full rounded-md border border-secondary px-3 outline-none",
          { "!border-red": errors[name] },
          className,
        )}
      />
    );
  },
);

NoticeTextField.displayName = "NoticeTextField";

export default NoticeTextField;
